export default __webpack_public_path__ + "static/media/N2P_1909.95513da1.jpg";